export default () => {
  $('.js-vote-button').on('click', function() {
    const $votedButton = $(this);
    if(window.VOTED) {
      $('#failedMessageModal').modal({});
      return;
    }
    const agencyId = $(this).data('agency');
    const userId = $(this).data('user');
    $.post({
      url: window.wp_data.ajax_url,

      data: {
        agency: agencyId,
        user: userId,
        action: 'ajax_voting_request',
        nonce: window.wp_data.vote_nonce,
      },
    }).done(function(data) {
      const d = JSON.parse(data);
      if(d.error) {
        $('#failedMessageModal').modal({});
      } else {
        window.VOTED = true;
        $('.r-voting-table').addClass('voted');
        $votedButton.addClass('voted-active');
        $('#successMessageModal h2').text(data.message);
        $('#successMessageModal').modal({});
      }
    }).fail(function(err){
      console.log(err);
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/util/voting.js